import React, { createContext, useState,useEffect, useContext } from 'react';
import Toast from './ChildComp/Toast';
const SharedDataContext = createContext();
export const useSharedDataContext = () => {
    return useContext(SharedDataContext);
};
export const SharedDataProvider = ({ children }) => {


    const [sharedData, setSharedData] = useState(() => {

        const storedData = sessionStorage.getItem('sharedData');
        return storedData ? JSON.parse(storedData) : [];
    });

    const [sharedQuoteData, setSharedQuoteData] = useState(() => {
        const quoteData = sessionStorage.getItem('sharedQuoteData');
        return quoteData ? JSON.parse(quoteData) : [];
    });


    useEffect(()=>{
        sessionStorage.setItem('sharedData', JSON.stringify(sharedData));
        sessionStorage.setItem('sharedQuoteData', JSON.stringify(sharedQuoteData));
    }, [sharedData, sharedQuoteData]);

    const [toasts, setToasts] = useState([]);

    const showToast = (toastData) => {
        const { message, flag = "success", duration = 3000 } = toastData;
        const id = Date.now();
        setToasts([...toasts, { id, message, flag, duration }]);

        setTimeout(() => {
            setToasts((prevToast) => prevToast.filter(r => r.id !== id));
        }, [duration]);
    }


    return (
        <SharedDataContext.Provider value={{ sharedData, setSharedData, sharedQuoteData, setSharedQuoteData, showToast }}>
            {children}
            <div style={{
                position: "fixed",
                top: "10px",
                right: "10px",
                zIndex: 9999,  // Ensure it's above everything
                pointerEvents: "none",
            }}>
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        message={toast.message}
                        flag={toast.flag}
                        duration={toast.duration}
                        onClose={() => setToasts((prev) => prev.filter((t) => t.id !== toast.id))}
                    />
                ))}
            </div>
            </SharedDataContext.Provider>
        );
};